import { PhoneNumberUtil } from "google-libphonenumber";

const phoneUtil = PhoneNumberUtil.getInstance();

export const isPhoneValid = (phone) => {
  try {
    return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
  } catch (error) {
    return error;
  }
};

export const isCheckRS = (t) => t ? t : "";  

export const regexRemoveSomeCharacters = /[?#\$\\\/]/g;

export const slugValidate = /^[a-z0-9]+(?:-[a-z0-9]+)*$/g;

export const slugUrls = /^\/[A-Za-z0-9-]+\/?(?:[A-Za-z0-9-]+\/?)*$/g;





export const emailValidate = /^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/;
export const white_space_String = (string) => {
  let searchTerm =""
  string.split(" ").forEach(function(s) {
      if (s.search(/\./) !== -1) { s = "\""+s+"\""; }
      searchTerm += s + " ";
  })

  return searchTerm.trim();
}

export const matches = {
  img: /\.(jpg|jpeg|png)$/
}

